/**
 * Hardcoded legacy curriculum — mirrors user-service `legacy-module-catalog.ts`.
 * Source: cert2.sql `modules` + `module_quizzes`.
 */

export type LegacyModuleStepDefinition = {
  stepNumber: number;
  section: string;
  title: string;
  questionCount: number;
};

export type LegacyModuleDefinition = {
  versionNum: number;
  slug: string;
  totalSteps: number;
  steps: LegacyModuleStepDefinition[];
};

export const LEGACY_MODULE_CATALOG: Record<string, LegacyModuleDefinition> = {
  "sanctuary-2": {
    versionNum: 2,
    slug: "sanctuary-2",
    totalSteps: 15,
    steps: [
      { stepNumber: 1, section: "Mounting", title: "Installation Guidelines", questionCount: 5 },
      { stepNumber: 2, section: "Mounting", title: "Bracket Placement", questionCount: 2 },
      { stepNumber: 3, section: "Wiring", title: "Critical Loads Backup", questionCount: 3 },
      { stepNumber: 4, section: "Wiring", title: "Whole Home Backup", questionCount: 3 },
      { stepNumber: 5, section: "Wiring", title: "Wire in AC Solar", questionCount: 2 },
      { stepNumber: 6, section: "Wiring", title: "Wire in Backup Generator", questionCount: 7 },
      { stepNumber: 7, section: "Wiring", title: "DC Solar", questionCount: 1 },
      { stepNumber: 8, section: "Wiring", title: "DC Solar RSS", questionCount: 2 },
      { stepNumber: 9, section: "Wiring", title: "DC Solar Optimizer", questionCount: 3 },
      { stepNumber: 10, section: "Wiring", title: "Remote Shutdown", questionCount: 2 },
      { stepNumber: 11, section: "Wiring", title: "Battery Comms", questionCount: 1 },
      { stepNumber: 12, section: "Wiring", title: "CT Installation", questionCount: 2 },
      { stepNumber: 13, section: "Commissioning", title: "Commissioning the System", questionCount: 4 },
      { stepNumber: 14, section: "Commissioning", title: "PV Connection Warnings", questionCount: 1 },
      { stepNumber: 15, section: "Conclusion", title: "Interface Summary", questionCount: 4 },
    ],
  },
  "sanctuary-3": {
    versionNum: 3,
    slug: "sanctuary-3",
    totalSteps: 15,
    steps: [
      { stepNumber: 1, section: "Mounting", title: "Installation Guidelines", questionCount: 7 },
      { stepNumber: 2, section: "Mounting", title: "Bracket Placement", questionCount: 2 },
      { stepNumber: 3, section: "Wiring", title: "Critical Loads Backup", questionCount: 3 },
      { stepNumber: 4, section: "Wiring", title: "Whole Home Backup", questionCount: 3 },
      { stepNumber: 5, section: "Wiring", title: "AC Solar Wiring", questionCount: 2 },
      { stepNumber: 6, section: "Wiring", title: "Backup Generator Wiring", questionCount: 3 },
      { stepNumber: 7, section: "Wiring", title: "DC Solar Wiring", questionCount: 1 },
      { stepNumber: 8, section: "Wiring", title: "DC Solar RSS", questionCount: 2 },
      { stepNumber: 9, section: "Wiring", title: "DC Solar Optimizer", questionCount: 3 },
      { stepNumber: 10, section: "Wiring", title: "Remote Shutdown", questionCount: 2 },
      { stepNumber: 11, section: "Wiring", title: "Battery Communications", questionCount: 1 },
      { stepNumber: 12, section: "Wiring", title: "CT Installation", questionCount: 2 },
      { stepNumber: 13, section: "Commissioning", title: "Commissioning the System", questionCount: 6 },
      { stepNumber: 14, section: "Commissioning", title: "Safety Warning", questionCount: 1 },
      { stepNumber: 15, section: "Conclusion", title: "Interface Walkthrough", questionCount: 4 },
    ],
  },
};

export function getLegacyModuleDefinition(
  slug: string,
): LegacyModuleDefinition | null {
  return LEGACY_MODULE_CATALOG[slug] ?? null;
}

export function getLegacyModuleTotalSteps(slug: string): number | null {
  return getLegacyModuleDefinition(slug)?.totalSteps ?? null;
}
